import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiQueryResult } from '@euler/model/bi/result';
import { BiFunnelViz, BiPalette } from '@euler/model/bi/viz';
import { memo, useMemo, useState } from 'react';
import { ScrollView, View } from 'react-native';
import { BiVizMismatch } from './BiVizMismatch';
import { BiFunnelChart } from './chart/BiFunnelChart';
import { biFunnelModel } from './functions/biFunnelModel';

/**
 * A funnel at the width it is given. It sets its own height, a row per
 * stage, and scrolls when a fixed-size card is shorter.
 */
export const BiFunnelView = memo(
  ({
    viz,
    result,
    palette,
  }: {
    viz: BiFunnelViz;
    result: BiQueryResult;
    /** The dashboard's palette; a chat draft uses the default. */
    palette?: BiPalette;
  }) => {
    const { rpx } = useResponsiveContext();
    const model = useMemo(
      () => biFunnelModel(viz, result, palette),
      [viz, result, palette],
    );
    const [width, setWidth] = useState<number | null>(null);
    if (!model) return <BiVizMismatch />;
    return (
      <ScrollView
        style={{ flexGrow: 0, flexShrink: 1 }}
        contentContainerStyle={{ paddingVertical: rpx(4) }}
        nestedScrollEnabled
      >
        <View onLayout={event => setWidth(event.nativeEvent.layout.width)}>
          {width ? <BiFunnelChart model={model} width={width} /> : null}
        </View>
      </ScrollView>
    );
  },
);
